import { Params, useParams } from 'react-router-dom';

export const useSignupPageIdFromUrl = () => {
    const {signupPageId} = useParams() as Params<'signupPageId'>;
    const signupPageIdPath = parseInt(signupPageId as string);
    return signupPageIdPath;
};